export function authHeader() {
  // return authorization header with jwt token
  let user = JSON.parse(localStorage.getItem("user"));
  if (user && user.token) {
    return {
      Authorization: "Bearer " + user.token,
      Accept: "application/json",
      "X-Custom-Header": "WebApp",
    };
  } else {
    return { Accept: "application/json", "X-Custom-Header": "WebApp" };
  }
}


